// extracted by mini-css-extract-plugin
module.exports = {"container":"HighlightedKeyword_container__2FpFf"};